import(/* webpackMode: "eager", webpackExports: ["BlogPostClient"] */ "/home/runner/work/udata-site/udata-site/app/blog/[slug]/BlogPostClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogSchemaHead"] */ "/home/runner/work/udata-site/udata-site/components/BlogPage/BlogSchemaHead/BlogSchemaHead.tsx");
